import { render } from "./homeBottom.vue?vue&type=template&id=197a6da1&scoped=true"
import script from "./homeBottom.vue?vue&type=script&lang=js"
export * from "./homeBottom.vue?vue&type=script&lang=js"

import "./homeBottom.vue?vue&type=style&index=0&id=197a6da1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197a6da1"]])

export default __exports__